import defaultTenant from "@irati/identity/helpers/defaultTenant"
import Auth from "../types/ReduxAuth"

const defaultAuth: Auth = {
  userTenant: defaultTenant,
  apps: {},
  isSSO: false
}

export default defaultAuth
